'use strict';
function e(r) {
  return typeof r == "string" && (r = parseFloat(r)), r - Math.floor(r) !== 0 ? `$${r.toFixed(2)}` : `$${r}`;
}
export {
  e as formatPrice
};
